import {Text} from '@/components/atoms'
import {PromotionType} from '@/utils/constants/promotionConstants'
import {BuyMultipleProductsCondition} from './BuyMultipleProductsConditon'
import {BuySingleProductConditions} from './BuySingleProductConditions'
import {RewardDiscount} from './Rewards/RewardDiscount'

const PromotionsConditions = ({condition, promotionType, index, selectedPromotionCondition}) => {
  const renderConditionContent = () => {
    switch (promotionType) {
      case PromotionType.BUY_PRODUCT:
        return (
          <BuySingleProductConditions
            index={index}
            promotionCondition={condition}
            selectedPromotionCondition={selectedPromotionCondition}
          />
        )
      case PromotionType.STORE_DISCOUNT:
        return (
          <div className="flex items-center gap-4">
            <Text>{'Get'}</Text>
            <RewardDiscount
              index={index}
              promotionCondition={condition}
              selectedPromotionCondition={selectedPromotionCondition}
            />
          </div>
        )
      case PromotionType.WELCOME_DISCOUNT:
        return (
          <div className="flex items-center gap-4">
            <Text>{'Get'}</Text>
            <RewardDiscount
              index={index}
              promotionCondition={condition}
              textAfterInput="% off, after first order."
              selectedPromotionCondition={selectedPromotionCondition}
            />
          </div>
        )
      case PromotionType.BUY_MULTIPLE:
        return (
          <BuyMultipleProductsCondition
            index={index}
            promotionCondition={condition}
            selectedPromotionCondition={selectedPromotionCondition}
          />
        )
      default:
        return null
    }
  }

  return <div className="flex flex-wrap items-center gap-4 pt-2">{renderConditionContent()}</div>
}

export default PromotionsConditions
